/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getStoreLocatorCityPageContainer = (props: IncomingContent): Layout => ({
	name: 'TripleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [],
		second: [{ name: 'StoreLocatorCity', id: 'store_locator_city' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
